import { vDefaultValues } from '@sword-health/input-validation/src/scripts/defaults'
import { z } from 'zod'
import { NOTE_TITLE_MAX_LENGTH } from '@/scripts/app-configs/constants'

const baseNoteSchema = z.object({
  title: z.string().max(NOTE_TITLE_MAX_LENGTH),
  body: z.string().max(vDefaultValues.freeField.maxlength),
})

export { baseNoteSchema }
